const targetNode = document.querySelector(".cart__subtotal");

if (targetNode) {
  const config = {
    childList: true,
    characterData: true,
    subtree: true
  };

  let mutationCount = 0; 

  const observer = new MutationObserver((mutationsList, obs) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.target.className === "money") {
        mutationCount++;

        window.BSS_B2B?.observer?.cartSubject?.notifyObserver('CartUpdate', 'CartMutate');

        if (mutationCount >= 3) {
          obs.disconnect();
          break;
        }
      }
    }
  });

  observer.observe(targetNode, config);
}

document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`[action="/search"] [name="q"]`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});


const variantSelection = document.querySelector(".options-selection__option-name");

if (variantSelection) {
  const config = {
    childList: true,      
    characterData: true,   
    subtree: true          
  };

  const callback = (mutationsList, observer) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList" && mutation.target.className === "options-selection__option-name") {
        const productForm = document.querySelector("[bss-b2b-main-product-form]");
        if (productForm) window.BSS_B2B?.observer?.productSubject?.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
      } 
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(variantSelection, config);
}
